import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from "../../pages/home/SideBar/Sidebar";
import Header from "../../pages/home/Header";
import { useLayout } from './useLayout';
import './layout.css';
import TrendingPanel from '../trending/TrendingPanel';
import { FloatingChatManager } from '../../features/chat';


function MainLayout() {
  const { isMobile, toggleMobileMenu } = useLayout();
  const isSidebarOpen = useSelector(state => state.ui.isSidebarOpen);
  const location = useLocation();
  const isProjectsPage = location.pathname.startsWith('/projects');
  const isProfileRoute = location.pathname === '/profile' || location.pathname.startsWith('/profile/');
  const isFilesRoute = location.pathname === '/files';

  // Show right panel for profile and files routes
  const showRightPanel = isProfileRoute || isFilesRoute;

  return (
    <div className={`layout main-layout ${isProjectsPage ? 'projects-route' : ''} ${showRightPanel ? 'has-right-panel' : ''}`}>
      <div className="layout-header">
        <Header onMenuClick={toggleMobileMenu} isMobile={isMobile} />
      </div>

      {/* Fixed sidebar for desktop */}
      <div className={`layout-sidebar ${isMobile ? 'mobile' : ''} ${isSidebarOpen ? 'open' : ''}`}>
        <Sidebar />
      </div>

      {/* Mobile menu overlay */}
      {isMobile && isSidebarOpen && (
        <div className="mobile-menu-overlay" onClick={toggleMobileMenu}>
          <div className="mobile-menu">
            <Sidebar />
          </div>
        </div>
      )}

      {/* Main content area for non-home routes */}
      <div className="layout-content">
        <div className="content-container">
          <Outlet context={{ isMobile, isHomePage: false }} />
        </div>
      </div>

      {/* Right panel (fixed) on Profile and Files routes */}
      {showRightPanel && (
        <div className="right-panel">
          <div className="right-panel-content">
            <TrendingPanel />
            <FloatingChatManager />
          </div>
        </div>
      )}
    </div>
  );
}

export default MainLayout;
